import * as React from "react";
import { DismissRegular } from "@fluentui/react-icons";
import {
    MessageBar,
    MessageBarActions,
    MessageBarBody,
    Button,
    makeStyles,
    tokens,
    MessageBarIntent,
    typographyStyles,
} from "@fluentui/react-components";

interface NewformaMessageBarProps {
    intent: MessageBarIntent;
    body: React.ReactNode;
    onDismiss?: () => void;
}

const useStyles = makeStyles({
    messageBar: {
        ...typographyStyles.caption1,
        color: tokens.colorNeutralForeground1,
        paddingBlock: tokens.spacingVerticalS,
        marginBottom: tokens.spacingVerticalS,
    },
});

export const NewformaMessageBar = (props: NewformaMessageBarProps): JSX.Element => {
    const styles = useStyles();

    return (
        <MessageBar
            className={styles.messageBar}
            as="div"
            intent={props.intent}
            shape="rounded"
            politeness="polite"
            layout="auto"
        >
            <MessageBarBody>{props.body}</MessageBarBody>
            {props.onDismiss && (
                <MessageBarActions
                    containerAction={
                        <Button
                            aria-label="dismiss"
                            appearance="transparent"
                            icon={<DismissRegular />}
                            onClick={props.onDismiss}
                        />
                    }
                ></MessageBarActions>
            )}
        </MessageBar>
    );
};
